import { hasRecordReference } from '../objects/guards';
import Tool, {
  type IToolActionInput,
  type IToolEnabledInput,
  simpleToolButton,
} from './Tool';
import sizeToFit from '../assets/icons/scaleFrameToFit.svg';
import { svgToIcon } from '../utils/svg';
import type ShapeRecord from '../shapes/ShapeRecord';
import type Shape from '../objects/Shape';

class ToolCardSizeToFit extends Tool {
  static toolName = 'Size to fit';

  static action({ selection, controller }: IToolActionInput) {
    const objects = selection?.getObjects() as Shape<ShapeRecord>[];

    objects.forEach(object => {
      object.shape.sizeToFit();
    });
    controller.canvas.requestRenderAll();
  }

  static available({ selection }: IToolEnabledInput): boolean {
    return Boolean(selection?.getObjects().every(hasRecordReference));
  }

  static buttonComponent() {
    return simpleToolButton(ToolCardSizeToFit, svgToIcon(sizeToFit));
  }
}

export default ToolCardSizeToFit;
